export default __webpack_public_path__ + "static/media/T_Carpet_Tiles.bf246af0.jpg";